import { render, staticRenderFns } from "./common-header.vue?vue&type=template&id=730945c6&scoped=true&"
import script from "./common-header.vue?vue&type=script&lang=js&"
export * from "./common-header.vue?vue&type=script&lang=js&"
import style0 from "./common-header.vue?vue&type=style&index=0&id=730945c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730945c6",
  null
  
)

export default component.exports